export default "__VITE_ASSET__DC47hMxE__"